import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import SuccessIcon from '~/assets/images/success-round.svg';

interface SuccessStateProps {
  title: string;
  description?: string;
}

const SuccessState = ({ title, description = '' }: SuccessStateProps) => {
  const { t } = useTranslation('common');
  return (
    <Stack alignItems="center" spacing={1}>
      <Box
        component="img"
        src={SuccessIcon}
        alt={t('successAlt') as string}
        sx={{
          width: 48,
          height: 48,
        }}
      />

      <Typography variant="h3" textAlign="center">
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {description}
        </Typography>
      )}
    </Stack>
  );
};

export default SuccessState;
